<app-top-bar></app-top-bar>
<div class="medical-staff-main-container">
  <div class="medical-staff-content">
    <router-outlet></router-outlet>
  </div>
</div>
